import React, { useState, useEffect } from "react";
import { Box, Typography, Stack, Grid } from "@mui/material";
import StackedCarousel from "../../components/StackedCarousel";
import NftCard from "../../components/NftCard"; 
import ApiService from "../../services/api-service";
import { getErrorString, getUserId } from "./../../constants/function";
import notifier from "./../../components/Notifier";
import { useParams, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Top3Nfts from "./Top3Nft";
import Collection from "../../assets/common/resources/collection.png"; // Placeholder image

export default function Nft() {
  const { t } = useTranslation("common");
  const history = useHistory(); // Use history for navigation
  const [nft, setNft] = useState([]);
  const [pageNo, setPageno] = useState(1);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const userId = getUserId();
  const [topNfts, setTopNfts] = useState([]);  // Top 3 NFTs

  const { tab } = useParams();

  // Function to fetch User NFT
  const getUserNft = async (next) => {
    try {
      setLoading(true);
      const response = await ApiService.USER_NFT_MUSIC({
        userId: userId,
        pageSize: 7,  // Set pageSize to 7 to fetch 7 items
        pageNo: next,
      });

      if (response["result"].length === 0) {
        setNft([]);
      } else {
        setNft((prevNft) => [...prevNft, ...response["result"]]);
      }

      setLoaded(response["result"].length < 7);  // Determine if all items are loaded
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  useEffect(() => {
    getUserNft(pageNo);
  }, [tab]);

  // Navigate to NFT Details Page
  const handleCardClick = (nftId, nftFallbackId) => {
    const id = nftId ? nftId : nftFallbackId;
    history.push(`/app/MyNft/${id}`);
  };

  // Render function for each NFT item
  const renderNftItem = (nftItem) => (
    <Box
      key={nftItem._id}
      className="__nft_music_card"
      onClick={() =>
        handleCardClick(nftItem.nftId, nftItem._id) // Handle click to navigate
      }
      sx={{
        cursor: "pointer", // Add pointer cursor to indicate clickable cards
      }}
    >
      <NftCard nft={nftItem} />
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        marginTop="0px"
      >
        <Stack>
          <Typography className="fs-16" title={nftItem?.title}>
            {nftItem?.title}
          </Typography>
          {nftItem["owner"] && (
            <Typography className="fs-14 fade-text">
              {nftItem["owner"].name}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Box>
  );

  return (
    <Box sx={{ position: "relative", height: "100vh" }}>
      {/* Main Layout Container */}
      <Grid container sx={{ height: "100%" }}>
        {/* Main Content Area (80% Width) */}
        <Grid item xs={12} md={9} sx={{ overflowY: "auto", padding: "20px" }}>
          {/* StackedCarousel */}
          {nft.length > 0 ? (
            <Box
              sx={{
                position: "relative",
                top: "30%",                   // Start the carousel 50% down
                transform: "translateY(-30%)", // Shift the carousel up by 50% of its height
              }}
            >
              <StackedCarousel
                items={nft}               // The array of NFT items to display
                renderItem={renderNftItem} // Custom function to render each NFT item
                slidesToShow={7}           // Number of visible slides
              />
            </Box>
          ) : (
            <Box
              sx={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "75%", // Full available height
                position: "relative",  // Relative positioning to contain the absolute text
              }}
            >
              <img 
                src={Collection}  // Placeholder image
                alt="Collection Placeholder"
                style={{
                  maxWidth: "60%",            // Smaller size
                  height: "auto", 
                  filter: "brightness(50%)",  // Darken the image
                  margin: "auto",             // Center horizontally
                }} 
              />
              {/* Centered Text */}
              <Typography 
              sx={{ 
                fontFamily: "var(--font-body)", // Set font to Inter
                fontWeight: "bold",              // Make the text bold
                fontSize: "24px",                // Customize the font size
                color: "#fff",
                position: "absolute",  // Positioning text over the image
                top: "30%", 
                left: "50%", 
                transform: "translate(-30%, -30%)",  // Center horizontally and vertically
              }}
            >
              {loading ? "Loading Collection..." : "Start Your Collection"}
            </Typography>
            </Box>
          )}
        </Grid>

        {/* Top 3 NFTs Sidebar (20% Width) */}
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            height: "100%",
            padding: "20px",              // Padding for internal content
            boxSizing: "border-box",      // Ensure padding is included
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start", // Align content to the top
            alignItems: "center",         // Center the Top 3 NFTs horizontally
            overflowY: "auto",            // Scroll if content overflows
          }}
        >
          <Top3Nfts nfts={topNfts} loading={loading} />
        </Grid>
      </Grid>
    </Box>
  );
}
